import { match } from 'ts-pattern';
import { ArtistStatus } from '../graphql/operations';

export function getArtistStatusLabel(status: ArtistStatus) {
  return match(status)
    .with(ArtistStatus.Core, () => 'Core')
    .with(ArtistStatus.Orion, () => 'Orion')
    .otherwise(() => 'Pending Orion Request');
}
